<div class="form-group" [ngClass]="field.customClass">
  <label [for]="'field' + field.name">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? "*" : "" }}</span>
  </label>
  <select
    [name]="field.name"
    [formControl]="control"
    class="form-select form-control"
    [class.is-invalid]="(control.touched || control.value) && control.errors"
    [class.is-valid]="control.touched && control.value"
    [id]="'field' + field.name"
    [attr.disabled]="disabled || null"
  >
    <option value=""></option>
    @for (opt of options; track opt.key) {
      <option [value]="opt.key">{{ opt.value }}</option>
    }
  </select>
</div>
